exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/worsening/worsening-worse-details/worsening-worse-details.component.scss
// module id = ../../../../../src/app/components/worsening/worsening-worse-details/worsening-worse-details.component.scss
// module chunks = main